import React, { useEffect } from 'react';

export default HiddenField;

function HiddenField(props) {
  const ref = React.createRef();
  const { fields, copyFrom, id } = props;

  useEffect(() => {
    ref.current.value = fields[copyFrom];
  }, [fields[copyFrom]]);

  return <input ref={ref} type='hidden' id={id} name={id} />;
}
